import {
  ASYNC_FETCH,
  ASYNC_FETCH_SUCCESSPLAN,
  ASYNC_FETCH_FAILURE,
  ASYNC_FETCH_INVALIDATE,
  SET_SELECTED_PLAN,
  SET_SELECTED_OFFER,
  FIRST_CURRENT_PLAN,
  STOP_API_CALL,
  DISABLE_REVIEW_BAR
 
} from '../constants';

import { updateObject } from '../../../shared/utilities/reducer';
import common from '../../../shared/utilities/common';

const initialState = {
  isFetching: true,
  statusCode: "",
  statusMessage: "",
  errorMessage: '',
  errorDesc: '',
  actionName: '',
  actionValue: '',
  errorObj: {},
  pageData: "",
  selectedPlan: {},
  offerValue: {},
  stopAPICall: false,
  firstPlanCheck: true
 
}


export const asyncFetch = (state, action) => {
  console.log("getSectionsBegin called")
  return updateObject(state, {
    isFetching: true
  });
};

export const asyncFetchSuccess = (state, action) => {
  let responseCode = action.msResp && action.msResp.responseInfo && action.msResp.responseInfo.responseCode;
  let responseMessage = action.msResp && action.msResp.responseInfo && action.msResp.responseInfo.responseMessage;
  let responseBody = action.msResp && action.msResp.body;

  return updateObject(state, {
    isFetching: false,
    statusCode: responseCode,
    statusMessage: responseMessage,
    errorMessage: common.isError(responseCode, responseMessage, responseBody),
    errorDesc: common.isErrorDesc(responseCode, responseMessage, responseBody),
    actionName: common.isActionName(responseCode, responseMessage, responseBody),
    actionValue: common.isActionValue(responseCode, responseMessage, responseBody),
    errorObj: responseCode !== "00" && action.msResp && action.msResp.responseInfo ? action.msResp.responseInfo.sectionErrors : null,
    pageData: responseBody
  });
};

export const asyncFetchFailed = (state, action) => {

  //Dont Delete this code untill implementing code to handel 500 status code error
  let msResp = action && action.err && action.err.response && action.err.response.data;
  let responseCode = msResp && msResp.responseInfo && msResp.responseInfo.responseCode;
  let responseMessage = msResp && msResp.responseInfo && msResp.responseInfo.responseMessage;
  let body = msResp && msResp.body;
  return updateObject(state, {
    isFetching: false,
    pageData: {},
    statusCode: responseCode ? responseCode : '',
    errorMessage: common.isError(responseCode, responseMessage, body),
    errorDesc: common.isErrorDesc(responseCode, responseMessage, body),
    actionName: common.isActionName(responseCode, responseMessage, body),
    actionValue: common.isActionValue(responseCode, responseMessage, body),
    errorObj: responseCode !== "00" && msResp && msResp.responseInfo ? msResp.responseInfo.sectionErrors : action.err,
  });
};




export const setSelectedPlanValue = (state, action) => {
  return updateObject(state, {
    selectedPlan: action.data
  });
};

export const isFirstPlanCurrent = (state, action) => {
  return updateObject(state, {
    firstPlanCheck: action.data
  });
};


export const disableReviewProgressBar = (state, action) => {
  return updateObject(state, {
    disableReview: action.data
  });
};



export const setSelectedOfferValue = (state, action) => {
  return updateObject(state, {
    offerValue: action.data
  });
};

export const setStopApiCall = (state, action) => {
  return updateObject(state, {
    stopAPICall: action.data
  });
};

export const PlanSelectionReducer = (state = initialState, action) => {

  const { type } = action;
  switch (type) {
    case ASYNC_FETCH:
      return asyncFetch(state, action);
    case ASYNC_FETCH_SUCCESSPLAN:
      return asyncFetchSuccess(state, action);
    case ASYNC_FETCH_FAILURE:
      return asyncFetchFailed(state, action);
    // case ASYNC_FETCH_INVALIDATE:
    //   return Object.assign({}, state, { isFetching: false, pageData: {} });
    case SET_SELECTED_PLAN:
      return setSelectedPlanValue(state, action);
    case FIRST_CURRENT_PLAN:
      return isFirstPlanCurrent(state, action);
    case SET_SELECTED_OFFER:
      return setSelectedOfferValue(state, action);
    case STOP_API_CALL:
      return setStopApiCall(state, action);
    case DISABLE_REVIEW_BAR:
      return disableReviewProgressBar(state, action);
    
    default:
      return state;
  }
};

